<template>
  <div :class="{'nav-open': $sidebar.showSidebar}">
    <router-view></router-view>
    <div style="display: none;">
      <!-- Link to public images to force inclusion in portal -->
      <img src="/email-assets/box-head.png" />
      <img src="/email-assets/ziperase_logo_Light.png" />
    </div>
  </div>
</template>

<script>
export default {
  name: "App"
};
</script>
